import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=4ee49882&scoped=true&"
import script from "./AddressList.vue?vue&type=script&lang=ts&"
export * from "./AddressList.vue?vue&type=script&lang=ts&"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=4ee49882&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee49882",
  null
  
)

export default component.exports